<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div v-if="coupons">
      <b-modal
          id="modal-delete"
          cancelTitle="Cancel"
          centered
          ok-title="Delete"
          title="Delete Coupon"
          @ok="deleteCoupon"
      >
        <span>Are You Sure ?</span>
      </b-modal>
      <!-- Table Container Card -->
      <b-card
          class="mb-0"
      >
        <b-row>
          <b-col class="mb-1" cols="12" md="12">
            <h1>Coupons</h1>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group label="Search">
              <debouncer :placeHolder="`search by`" @setValue="getsearchValue"></debouncer>
            </b-form-group>
          </b-col>
          <b-col class="d-flex flex-column -start  mb-1 mb-md-0"
                 cols="12" md="3"
          >
            <b-form-group label="Count">
              <v-select
                  v-model="perPage"
                  :clearable="false"
                  :options="perPageOptions"
                  class="per-page-selector  "
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
            ref="refUserListTable"
            :fields="myTableColumns"
            :items="coupons"
            bordered
            class="position-relative"
            empty-text="Nothing found!"
            primary-key="id"
            responsive
            show-empty
            striped
        >
          <template #cell(edit)="data">
            <b-link :to="`/apps/site-setting/coupon/update/${data.item.couponId}`" class="cursor-pointer">
              <feather-icon class="text-primary" icon="EyeIcon" size="20"/>
            </b-link>
          </template>

          <template #cell(delete)="data">
            <span v-b-modal.modal-delete class="cursor-pointer" @click="setSelectedCoupon(data.item)">
              <feather-icon class="text-danger" icon="TrashIcon" size="20"/>
            </span>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <!-- Pagination -->
            <b-col
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
                cols="12"
                sm="6"
            >
              <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="totalCount"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>


  </b-overlay>
</template>

<script>

import { BCard, BCol, BFormGroup, BLink, BModal, BOverlay, BPagination, BRow, BTable } from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { DeleteCoupon, GetAllCoupons } from '@/libs/Api/Coupon'
import Debouncer from '@/views/components/debouncer.vue'

export default {
  title: 'manage coupons',
  name: 'manage-coupons',
  data() {
    return {
      overlay: false,
      coupons: null,
      totalCount: null,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {
          key: 'code',
          label: 'code',
          sortable: true
        },
        {
          key: 'maxUse',
          label: 'capacity',
          sortable: true
        },
        {
          key: 'used',
          label: 'used',
          sortable: true
        },
        {
          key: 'edit',
          label: 'edit'
        },
        {
          key: 'delete',
          label: 'delete'
        },
      ],
      pageNumber: 1,
      search: '',
      selectedCoupon: null,
    }
  },
  async created() {
    await this.getAllCoupons()
  },
  watch: {
    search: function () {
      this.getAllCoupons()
    },
    currentPage: function () {
      this.getAllCoupons()
    },
    perPage: function () {
      this.getAllCoupons()
    }
  },
  methods: {
    getsearchValue(data){
      this.search  = data
      this.getAllCoupons()
    },
    setSelectedCoupon(item) {
      this.selectedCoupon = JSON.parse(JSON.stringify(item))
    },
    async getAllCoupons() {
      let _this = this
      _this.overlay = true

      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        search:_this.search
      }

      let getAllCoupons = new GetAllCoupons(_this)
      getAllCoupons.setParams(data)
      await getAllCoupons.fetch(function (content) {
        _this.overlay = false
        _this.coupons = content.data.data
        _this.totalCount = content.data.totalCount
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },
    async deleteCoupon() {
      let _this = this
      _this.overlay = true

      let data = {
        id: _this.selectedCoupon.couponId
      }
      let deleteCoupon = new DeleteCoupon(_this)
      deleteCoupon.setParams(data)
      await deleteCoupon.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Done`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.getAllCoupons()
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },

  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    BFormGroup,
    BModal,
    Debouncer,
    vSelect,
  },
}
</script>

<style scoped>

</style>
